/* eslint-disable import/prefer-default-export */
import { Argument as ClassNameType } from 'classnames';

import { numberWord } from '../../../common/SimilarArticles/SimilarArticlesHelpers';
import { ContentSectionThemeProps } from '../../../fastlane/contentSection/ContentSection';

import styles from './TrackerHome.scss';

const expandableSectionNames = numberWord.slice(0, 2).map((n) => ({
  caption: `expandable_section_${n}_caption`,
  contentArea: `expandable_section_${n}_content`,
  description: `expandable_section_${n}_description`,
  imgAlt: `expandable_section_${n}_image_alt`,
  imgSrc: `expandable_section_${n}_image`,
  title: `expandable_section_${n}_title`,
}));

const createExpandableSectionData = (acf: any, names: any) => {
  if (!acf) {
    return [];
  }

  return Object.entries(acf).reduce((acc: any, [name, val]) => {
    if (name.includes(names.caption) && val) {
      const keys = name.split(names.caption);
      const content = acf[`${names.contentArea}${keys[1]}`];
      if (content) {
        acc.push({
          answer: content,
          question: val,
        });
      }
    }
    return acc;
  }, []);
};

export const generateExpandableSectionData = (wpData: any) => {
  if (wpData) {
    return (
      expandableSectionNames.map((n) => ({
        content: createExpandableSectionData(wpData, n),
        description: wpData[n.description],
        imgAlt: wpData[n.imgAlt],
        imgSrc: wpData[n.imgSrc],
        title: wpData[n.title],
      }))
    );
  }
  return [];
};

const contentSectionNames = numberWord.slice(0, 7).map((n) => ({
  contentArea: `section_${n}_body_area`,
  imageAlt: `section_${n}_image_area_alt`,
  imageArea: `section_${n}_image_area`,
  title: `section_${n}_title`,
}));

export const generateContentSectionData = (wpData: any) => {
  if (wpData) {
    return contentSectionNames.map((n) => ({
      contentArea: wpData[n.contentArea],
      imageAlt: wpData[n.imageAlt],
      imageArea: wpData[n.imageArea],
      title: wpData[n.title],
    }));
  }
  return [];
};

export const getContentSectionTheme = (index: number) : {
  className: ClassNameType;
  theme: ContentSectionThemeProps;
} => {
  switch (index) {
  case (0):
    return {
      className: styles.depreciationBox,
      theme: 'white',
    };
  case (1):
    return {
      className: styles.carBox,
      theme: 'black',
    };
  case (2):
    return {
      className: styles.whiteBox,
      theme: 'primary-light-yellow',
    };
  case (3):
    return {
      className: styles.blueBox,
      theme: 'primary-light-yellow',
    };
  default:
    return {
      className: null,
      theme: 'primary-light-yellow',
    };
  }
};
